import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
export default function RolePreview() {
  const { realUser, preview, setPreview, organizations, organizationError } = useAuth();
  const { t } = useLang();
  if (realUser?.role !== "admin") return null;
  return <div className="flex min-w-0 items-center gap-1" data-testid="role-preview-toolbar">
    <span className="hidden text-xs text-muted-foreground md:inline">{t("Weergave als", "View as")}</span>
    <select aria-label={t("Weergave als", "View as")} title={t("Weergave als", "View as")} className="h-9 max-w-[110px] rounded-md border border-border bg-background px-1 text-xs" value={preview?.role || "admin"} onChange={e => setPreview(e.target.value, preview?.organization_id)}>
      <option value="admin">{t("Admin", "Admin")}</option>
      <option value="user">{t("Klant", "Customer")}</option>
      <option value="manager">{t("Manager", "Manager")}</option>
    </select>
    {preview && <select aria-label={t("Organisatievoorbeeld", "Organization preview")} title={organizationError || t("Kies een organisatie", "Choose an organization")} className="h-9 max-w-[120px] rounded-md border border-border bg-background px-1 text-xs" value={preview.organization_id || ""} onChange={e => setPreview(preview.role, e.target.value)}>
      <option value="">{t("Kies klant…", "Choose customer…")}</option>
      {organizations.map(org => <option key={org.id} value={org.id}>{org.name}</option>)}
    </select>}
  </div>;
}
export function RolePreviewBanner() {
  const { preview, setPreview, user, organizationError } = useAuth();
  const { t } = useLang();
  if (!preview) return null;
  return <div className="flex flex-wrap items-center justify-between gap-2 border-b border-amber-500/30 bg-amber-500/10 px-4 py-2 text-xs" role="status" data-testid="role-preview-banner">
    <span>{t("Alleen-lezen voorbeeld", "Read-only preview")} · {preview.role === "user" ? t("Klant", "Customer") : "Manager"} · {user.organization?.name || t("Geen klant gekozen", "No customer selected")}{organizationError ? ` · ${organizationError}` : ""}</span>
    <button className="rounded border border-current px-2 py-1 font-semibold" onClick={() => setPreview("admin")}>{t("Stop voorbeeld", "Stop preview")}</button>
  </div>;
}
